export default {
  en: {
    title: 'Availability',
    subtitle: 'List of availabilities to use with calendars.',
  },
  es: {
    title: 'Disponibilidad',
    subtitle: 'Listado de disponibilidades para utilizar en calendarios.',
  },
  fr: {
    title: 'Disponibilité',
    subtitle: 'Liste des disponibilités à utiliser dans les calendriers.',
}
};
